import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../api/axios';
import bgImg from '../assets/bg-imag.png';

export default function GuestForm() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    email: '',
    mobile: '',
    looking_for_training: '',
    course_query: '',
    assessment_id: ''
  });

  localStorage.setItem('assessment_id', form.assessment_id);

  useEffect(() => {
    if (slug) {
      setForm(prev => ({ ...prev, assessment_id: slug }));
    }
  }, [slug]);

  const startTest = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/guest-test/start', form);

      localStorage.setItem('guest_user_id', res.data.guest_user_id);
      localStorage.setItem('user_assessment_id', res.data.user_assessment_id);
      localStorage.setItem('assessment_id', form.assessment_id); // <== SLUG

      // navigate(`/${form.assessment_id}/questions/1`);
      navigate(`/${form.assessment_id}/questions/1`);

    } catch (err) {
      alert('Could not start test');
    }
  };

  return (
    <div className="min-h-screen flex items-start justify-center px-4 py-5"
      style={{
        backgroundImage: `url(${bgImg})`, // Correct use of template literals to inject bgImg
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="w-full max-w-md bg-white rounded-xl border border-[#D9D9D9] p-8">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Kindly Fill The Form
        </h2>
        <form onSubmit={startTest} className="space-y-5">
          <div>
            <label className="block mb-1 text-[#080808] text-[16px] font-semibold">Name</label>
            <input
              type="text"
              placeholder="Your name"
              className="w-full border border-[#D9D9D9] rounded-md px-4 py-[8px] focus:outline-none focus:ring-[#E50914] focus:border-[#E50914]"
              onChange={e => setForm({ ...form, name: e.target.value })}
              required
            />
          </div>
          <div>
            <label className="block mb-1 text-[#080808] text-[16px] font-semibold">Email</label>
            <input
              type="email"
              placeholder="you@example.com"
              className="w-full border border-[#D9D9D9] rounded-md px-4 py-[8px] focus:outline-none focus:ring-[#E50914] focus:border-[#E50914]"
              onChange={e => setForm({ ...form, email: e.target.value })}
              required
            />
          </div>
          {/* <div>
            <label className="block mb-1 text-[#080808] text-[16px] font-semibold">Mobile</label>
            <input
              type="tel"
              placeholder="10-digit mobile"
              className="w-full border border-[#D9D9D9] rounded-md px-4 py-[8px] focus:outline-none focus:ring-[#E50914] focus:border-[#E50914]"
              onChange={e => setForm({ ...form, mobile: e.target.value })}
              required
            />
          </div> */}

          <div>
  <label className="block mb-1 text-[#080808] text-[16px] font-semibold">
    Mobile
  </label>
  <input
    type="tel"
    placeholder="10-digit mobile"
    className="w-full border border-[#D9D9D9] rounded-md px-4 py-[8px] focus:outline-none focus:ring-[#E50914] focus:border-[#E50914]"
    value={form.mobile}
    onChange={e => {
      // Allow only numbers
      const onlyNums = e.target.value.replace(/[^0-9]/g, '');
      setForm({ ...form, mobile: onlyNums });
    }}
    minLength={10}       // minimum 10 digits
    maxLength={10}       // maximum 10 digits
    pattern="\d{10}"     // regex validation for exactly 10 digits
    required
  />
</div>


          <div>
            {/* Looking for Training Select */}
            <label className="block mb-1 text-[#080808] text-[16px] font-semibold">
              Are you Looking for a Training Program?*
            </label>
            <select
              className="w-full border border-[#D9D9D9] rounded-md px-4 py-[8px] focus:outline-none focus:ring-[#E50914] focus:border-[#E50914]"
              value={form.looking_for_training}
              onChange={(e) =>
                setForm({ ...form, looking_for_training: e.target.value, course_query: "" })
              }
              required
            >
              <option value="">-- Select --</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>

          {/* Conditionally Show Textarea */}
          {form.looking_for_training === "Yes" && (
            <div className="mt-4">
              <label className="block mb-1 text-[#080808] text-[16px] font-semibold">
                Please Mention Course/Query*
              </label>
              <textarea
                placeholder="Enter your course or query"
                className="w-full border border-[#D9D9D9] rounded-md px-4 py-[8px] focus:outline-none focus:ring-[#E50914] focus:border-[#E50914]"
                value={form.course_query}
                onChange={(e) => setForm({ ...form, course_query: e.target.value })}
                required={form.looking_for_training === "Yes"} // required only if Yes
              />
            </div>
          )}

          <button
            type="submit"
            className="inline-block bg-bg-gradient-orange text-white font-semibold px-6 py-3 rounded shadow hover:opacity-90 transition"
          >
            Start Test
          </button>
        </form>
      </div>
    </div>
  );
}
